<template>
  <div class="over-wapper">
    <div class="over-ipt-wapper">
      <p>{{ popTitle }}</p><el-input
        size="small"
        v-model="val"
        placeholder="请输入内容"/>
    </div>
    <p style="text-align: center">如果是请点击确定按钮 ，否则请点取消</p>
    <div>
      <el-button type="primary">确定</el-button>
      <el-button type="warning">取消</el-button>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    popTitle: {
      type: String,
    }
  },
  data() {
    return {
      val: '',
    };
  },
  methods: {
  },
  components: {
  },
};
</script>
<style>
  .over-wapper{
    width: 100%;
    height:100%;
  }
  .over-wapper>.over-ipt-wapper p{
    width: 10%;
    float: left;
  }
  .over-wapper>.over-ipt-wapper .el-input{
    width: 90%;
    float: left;
  }
  .over-wapper>div{
    display: flex;
    justify-content:center;
    align-items: center;
  }
  .over-wapper>div:after{
    display: block;
    content: '';
    clear: both;
    height:0;
    opacity: 0;
  }
</style>
